<template>
    <div class="login-box">
    </div>
</template>

<script>

export default {
    name: 'Login',
    mounted () {
        window.oidc.userManager.signinRedirect()
    },
    components: {

    },
    data () {
        return {
        }
    },
    computed: {
    },
    watch: {
    },
    methods: {
    }
}
</script>

<style lang="scss">
</style>
